import React from 'react';
import MUIDialogContentText from '@mui/material/DialogContentText';
export const DialogContentText = props => /*#__PURE__*/React.createElement(MUIDialogContentText, props);
export default DialogContentText;